<template><section><h2>Donut Chart 环图</h2>
<block-demo tip="" source="const data = [
  {
    year: &#39;2001&#39;,
    population: 4
  },
  {
    year: &#39;2002&#39;,
    population: 38
  },
  {
    year: &#39;2003&#39;,
    population: 33.7
  },
  {
    year: &#39;2004&#39;,
    population: 30.7
  },
  {
    year: &#39;2005&#39;,
    population: 25.8
  },
  {
    year: &#39;2006&#39;,
    population: 31.7
  },
  {
    year: &#39;2007&#39;,
    population: 33
  },
  {
    year: &#39;2008&#39;,
    population: 46
  },
  {
    year: &#39;2009&#39;,
    population: 38.3
  },
  {
    year: &#39;2010&#39;,
    population: 2800
  }
]

const { Chart, Pie, Legend, Tooltip } = qcharts

const chart = new Chart({
  container: &#39;#app&#39;
})

chart.source(data, {
  row: &#39;year&#39;,
  value: &#39;population&#39;,
  //布局数据方式
  layoutScale: &#39;sqrt&#39;
})

const pie = new Pie({
  innerRadius: 0.4,
  radius: 0.7,
  clientRect: { top: &#39;10%&#39;, left: &#39;10%&#39;, right: &#39;10%&#39;, bottom: &#39;10%&#39; }
})
pie.style(&#39;sector&#39;, { lineWidth: 1, strokeColor: &#39;#fff&#39; })
pie.style(&#39;guideline&#39;, true)
pie.style(&#39;guideText&#39;, { fontSize: &#39;12px&#39; })

const legend = new Legend({ orient: &#39;vertical&#39;, align: [&#39;right&#39;, &#39;center&#39;] })

chart.append([pie, legend])
"><pre v-pre><code v-pre class="language-javascript"><span class="hljs-keyword">const</span> data = [
  {
    <span class="hljs-attr">year</span>: <span class="hljs-string">'2001'</span>,
    <span class="hljs-attr">population</span>: <span class="hljs-number">4</span>
  },
  {
    <span class="hljs-attr">year</span>: <span class="hljs-string">'2002'</span>,
    <span class="hljs-attr">population</span>: <span class="hljs-number">38</span>
  },
  {
    <span class="hljs-attr">year</span>: <span class="hljs-string">'2003'</span>,
    <span class="hljs-attr">population</span>: <span class="hljs-number">33.7</span>
  },
  {
    <span class="hljs-attr">year</span>: <span class="hljs-string">'2004'</span>,
    <span class="hljs-attr">population</span>: <span class="hljs-number">30.7</span>
  },
  {
    <span class="hljs-attr">year</span>: <span class="hljs-string">'2005'</span>,
    <span class="hljs-attr">population</span>: <span class="hljs-number">25.8</span>
  },
  {
    <span class="hljs-attr">year</span>: <span class="hljs-string">'2006'</span>,
    <span class="hljs-attr">population</span>: <span class="hljs-number">31.7</span>
  },
  {
    <span class="hljs-attr">year</span>: <span class="hljs-string">'2007'</span>,
    <span class="hljs-attr">population</span>: <span class="hljs-number">33</span>
  },
  {
    <span class="hljs-attr">year</span>: <span class="hljs-string">'2008'</span>,
    <span class="hljs-attr">population</span>: <span class="hljs-number">46</span>
  },
  {
    <span class="hljs-attr">year</span>: <span class="hljs-string">'2009'</span>,
    <span class="hljs-attr">population</span>: <span class="hljs-number">38.3</span>
  },
  {
    <span class="hljs-attr">year</span>: <span class="hljs-string">'2010'</span>,
    <span class="hljs-attr">population</span>: <span class="hljs-number">2800</span>
  }
]

<span class="hljs-keyword">const</span> { Chart, Pie, Legend, Tooltip } = qcharts

<span class="hljs-keyword">const</span> chart = <span class="hljs-keyword">new</span> Chart({
  <span class="hljs-attr">container</span>: <span class="hljs-string">'#app'</span>
})

chart.source(data, {
  <span class="hljs-attr">row</span>: <span class="hljs-string">'year'</span>,
  <span class="hljs-attr">value</span>: <span class="hljs-string">'population'</span>,
  <span class="hljs-comment">//布局数据方式</span>
  <span class="hljs-attr">layoutScale</span>: <span class="hljs-string">'sqrt'</span>
})

<span class="hljs-keyword">const</span> pie = <span class="hljs-keyword">new</span> Pie({
  <span class="hljs-attr">innerRadius</span>: <span class="hljs-number">0.4</span>,
  <span class="hljs-attr">radius</span>: <span class="hljs-number">0.7</span>,
  <span class="hljs-attr">clientRect</span>: { <span class="hljs-attr">top</span>: <span class="hljs-string">'10%'</span>, <span class="hljs-attr">left</span>: <span class="hljs-string">'10%'</span>, <span class="hljs-attr">right</span>: <span class="hljs-string">'10%'</span>, <span class="hljs-attr">bottom</span>: <span class="hljs-string">'10%'</span> }
})
pie.style(<span class="hljs-string">'sector'</span>, { <span class="hljs-attr">lineWidth</span>: <span class="hljs-number">1</span>, <span class="hljs-attr">strokeColor</span>: <span class="hljs-string">'#fff'</span> })
pie.style(<span class="hljs-string">'guideline'</span>, <span class="hljs-literal">true</span>)
pie.style(<span class="hljs-string">'guideText'</span>, { <span class="hljs-attr">fontSize</span>: <span class="hljs-string">'12px'</span> })

<span class="hljs-keyword">const</span> legend = <span class="hljs-keyword">new</span> Legend({ <span class="hljs-attr">orient</span>: <span class="hljs-string">'vertical'</span>, <span class="hljs-attr">align</span>: [<span class="hljs-string">'right'</span>, <span class="hljs-string">'center'</span>] })

chart.append([pie, legend])
</code></pre>
</block-demo></section></template><script>export default {components:{}}</script>